import type {z} from "zod";

import {
  ContactInputFields,
  PhoneNumberInput,
} from "@project/sdk/engineering/supplier-components-zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {contactFieldLabelIds} from "../../../../../../../support/messages/contact.messages";

const fields = ContactInputFields.shape;

export const addSupplierContactNameSchema = requiredStringSchema(
  fields.name,
  contactFieldLabelIds.name,
);
export const addSupplierContactEmailSchema = fields.email.or(zod.literal(""));

const addSupplierContactFormFieldsSchema = zod.object({
  name: addSupplierContactNameSchema,
  description: fields.description,
  email: addSupplierContactEmailSchema,
  phone: PhoneNumberInput.shape.nationalNumber.optional(),
  phonePrefix: PhoneNumberInput.shape.regionCode.optional(),
});

export const addSupplierContactFormSchema = addSupplierContactFormFieldsSchema.superRefine(
  (value, ctx) => {
    if (!value.email && !value.phone) {
      ctx.addIssue({code: "custom", message: "Email or phone is required", path: ["email"]});
    }
    if (value.phone && !value.phonePrefix) {
      ctx.addIssue({code: "custom", message: "Phone prefix is required", path: ["phonePrefix"]});
    }
  },
);
export type AddSupplierContactFormPayload = z.output<typeof addSupplierContactFormSchema>;

export const draftAddSupplierContactFormSchema = addSupplierContactFormFieldsSchema.partial();
export type DraftAddSupplierContactFormPayload = z.output<typeof draftAddSupplierContactFormSchema>;
